<template>
  <div>
    <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            {{ $t('pages.25myTrainings.toDay') }}
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ parsMonth($refs.calendar.title) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
              >
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(label, index) in typeToLabel" :key="index" @click="type = index">{{label}}</v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          :weekdays="weekdays"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card
            color="grey lighten-4"
            min-width="350px"
            max-width="700px"
            flat
            v-if="selectedEvent.detail"
          >
            <v-toolbar
              :color="selectedEvent.color"
              dark
            >
              <v-toolbar-title v-html="selectedEvent.detail.title"></v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <span class="text--primary" v-html="selectedEvent.detail.descrition"></span>
              <p class="subtitle-1 my-0 pt-2">{{ $t('components.calendar.links') }}</p>
              <ul class="text--primary">
                <li class="aval-calendar-list pt-2" v-for="(item, index) in selectedEvent.detail.links" :key="index" >
                  <v-icon>mdi-link</v-icon><a class="text-decoration-none pl-1" :href="item.url">{{item.name}}</a>
                </li>
              </ul>
            </v-card-text>

          </v-card>
        </v-menu>
      </v-sheet>
  </div>
</template>

<script>
import moment from 'moment'
import inputMixin from '@it-enterprise/web-app-common/src/mixins/input-mixin'
export default {
  name: 'dr-calendar',
  mixins: [inputMixin],
  data: () => ({
    focus: '',
    type: 'month',
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    weekdays: [1, 2, 3, 4, 5, 6, 0]
  }),
  computed: {
    events() {
      let events = this.getDataSourceField(this.model.Events)
      events.forEach(e => {
        e.start = moment(e.start, 'DD.MM.YYYY hh:mm:ss').toDate()
        
        e.end = moment(e.end, 'DD.MM.YYYY hh:mm:ss').toDate()
      })
      return events
    },
    typeToLabel () {
      return {
        month: this.$t('pages.25myTrainings.typeToLabel.month'),
        week: this.$t('pages.25myTrainings.typeToLabel.week'),
        day: this.$t('pages.25myTrainings.typeToLabel.day')
      }
    }
  },
  mounted() {
    // Для начального отображения месяца и года "Июнь 2020"
    this.$forceUpdate()
  },
  methods: {
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.focus = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => this.selectedOpen = true, 10)
      }
      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    // Посмотрел, что в $refs.calendar локализация "ru", но title приходит не локалезированым. как полечить - не нашел, написал свой парсер
    parsMonth(month) {
      let resultMonth = ''
      let parsMonth = month.split(' ')
      let onlyMonth = parsMonth[0]
      switch (onlyMonth) {
        case 'June':
          resultMonth = this.$t('pages.25myTrainings.month.June')
          break
        case 'July':
          resultMonth = this.$t('pages.25myTrainings.month.July')
          break
        case 'August':
          resultMonth = this.$t('pages.25myTrainings.month.August')
          break
        case 'September':
          resultMonth = this.$t('pages.25myTrainings.month.September')
          break
        case 'October':
          resultMonth = this.$t('pages.25myTrainings.month.October')
          break
        case 'November':
          resultMonth = this.$t('pages.25myTrainings.month.November')
          break
        case 'December':
          resultMonth = this.$t('pages.25myTrainings.month.December')
          break
        case 'January':
          resultMonth = this.$t('pages.25myTrainings.month.January')
          break
        case 'February':
          resultMonth = this.$t('pages.25myTrainings.month.February')
          break
        case 'March':
          resultMonth = this.$t('pages.25myTrainings.month.March')
          break
        case 'April':
          resultMonth = this.$t('pages.25myTrainings.month.April')
          break
        case 'May':
          resultMonth = this.$t('pages.25myTrainings.month.May')
          break
        default:
          return month
      }
      return `${resultMonth} ${parsMonth[1]}`
    }
  }
}
</script>
<style >
  .aval-calendar-list {
    list-style-type: none
  }
</style>